var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalBeneficiaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Total_Beneficiaries",
    "data-name": "Total Beneficiaries",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ebfdfd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "volunteer",
    transform: "translate(473.443 184.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9831",
    "data-name": "Path 9831",
    d: "M8.949,45.217V42.612a.821.821,0,0,0-.869-.869.821.821,0,0,0-.869.869v1.737H3.737V40.874a6.043,6.043,0,0,1,6.08-6.08v1.737a.79.79,0,0,0,.347.695l3.474,2.606a1.235,1.235,0,0,0,.521.174,1.235,1.235,0,0,0,.521-.174l3.474-2.606a.79.79,0,0,0,.347-.695v-1.65a5.354,5.354,0,0,1,4,3.561l1.824,5.906H20.935l-.695-2a.879.879,0,0,0-1.65.608l.869,2.606.087.087.782,1.563V53.9a.869.869,0,1,0,1.737,0V50.516a5.618,5.618,0,0,0,4.69,2.519,5.7,5.7,0,0,0,5.211-3.387l1.737-4a6.131,6.131,0,0,0,.521-2.432V40.874a1.862,1.862,0,0,0-.347-1.042l3.474-2.606a.79.79,0,0,0,.347-.695V33.578a8.651,8.651,0,0,0,4.343-7.47,3.862,3.862,0,0,0,3.474-3.822,2.549,2.549,0,0,0-.347-1.39,6.172,6.172,0,0,0,.347-1.737A12.2,12.2,0,0,0,33.356,7a12.063,12.063,0,0,0-7.73,2.779.862.862,0,1,0,1.129,1.3,10.137,10.137,0,0,1,6.514-2.345A10.454,10.454,0,0,1,43.692,19.16v.347a3.64,3.64,0,0,0-1.3-.347h-.434V17.423a.821.821,0,0,0-.869-.869,16.009,16.009,0,0,1-10.162-3.648l-.521-.434a1.01,1.01,0,0,0-.869-.174.858.858,0,0,0-.608.608,5.17,5.17,0,0,1-2.953,3.474A12.146,12.146,0,0,0,2,19.16V31.32a5.517,5.517,0,0,0,.434,2,.8.8,0,0,0,1.129.434A.8.8,0,0,0,4,32.623a3.485,3.485,0,0,1-.261-1.3V25.5a4.163,4.163,0,0,0,1.737.608,8.515,8.515,0,0,0,3.561,6.949A7.9,7.9,0,0,0,2,40.874V53.9a.821.821,0,0,0,.869.869.821.821,0,0,0,.869-.869V46.086H7.125l-.782,7.73a.863.863,0,0,0,.782.955h.087a.924.924,0,0,0,.869-.782ZM42.3,20.9a1.372,1.372,0,0,1,1.39,1.39,2.144,2.144,0,0,1-1.737,2.085V20.9ZM26.32,18.031a6.856,6.856,0,0,0,3.909-3.561A17.444,17.444,0,0,0,40.217,18.2v7.817a6.949,6.949,0,0,1-13.9,0ZM22.846,20.9h.347a1.372,1.372,0,0,1,1.39,1.39,2.144,2.144,0,0,1-1.737,2.085Zm0,5.211a4.163,4.163,0,0,0,1.737-.608V31.32a3.6,3.6,0,0,1-2.693,3.387,6.8,6.8,0,0,0-2.866-1.39,8.777,8.777,0,0,0,3.822-7.209ZM26.32,31.32a16.4,16.4,0,0,0,1.737,1.737,6,6,0,0,0-2.171.347,5.97,5.97,0,0,0,.434-2.085ZM3.737,22.287a1.372,1.372,0,0,1,1.39-1.39h.347v3.474A2.144,2.144,0,0,1,3.737,22.287Zm3.474,3.822V18.031A6.856,6.856,0,0,0,11.12,14.47a14.147,14.147,0,0,0,2.953,1.824.767.767,0,0,0,1.129-.347.83.83,0,0,0-.347-1.129,14.144,14.144,0,0,1-3.04-2l-.521-.434a1.01,1.01,0,0,0-.869-.174.858.858,0,0,0-.608.608,5.241,5.241,0,0,1-3.735,3.735.863.863,0,0,0-.608.869V19.16H5.127a2.549,2.549,0,0,0-1.39.347V19.16a10.423,10.423,0,1,1,20.846,0v.347a3.642,3.642,0,0,0-1.39-.347h-.347V17.423a.821.821,0,0,0-.869-.869,15.941,15.941,0,0,1-4.082-.521.853.853,0,0,0-.434,1.65,17.785,17.785,0,0,0,3.648.608v7.817a6.949,6.949,0,1,1-13.9,0ZM14.16,38.095l-2.606-1.911V34.447a8.624,8.624,0,0,0,2.606.434,8.624,8.624,0,0,0,2.606-.434v1.737Zm9.989-.174c-.174-.434-.347-.869-.521-1.216a5.969,5.969,0,0,1,4.43-1.911h.869v1.737a.79.79,0,0,0,.347.695l2.519,1.911h-2a1.742,1.742,0,0,0-1.737,1.737v1.737c0,.174,0,.261.087.347l.608,1.216-2,2Zm8.251,5.3a3.889,3.889,0,0,1-.347,1.737l-1.737,4A3.91,3.91,0,0,1,26.754,51.3a3.868,3.868,0,0,1-3.474-2.171l-1.65-3.04h3.214l.695,2a1.049,1.049,0,0,0,.608.608.7.7,0,0,0,.782-.261L30.4,44.957a.924.924,0,0,0,.174-1.042l-.782-1.477V40.874H32.4ZM35.874,36.1l-2.606,1.911L30.663,36.1V34.36a8.034,8.034,0,0,0,5.211,0Z",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(36 24)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(29 24)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9832",
    "data-name": "Path 9832",
    d: "M40.869,23.737h2.606a.869.869,0,1,0,0-1.737H40.869a.869.869,0,1,0,0,1.737Z",
    transform: "translate(-4.994 -1.971)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9833",
    "data-name": "Path 9833",
    d: "M31.869,23.737h2.606a.869.869,0,1,0,0-1.737H31.869a.869.869,0,1,0,0,1.737Z",
    transform: "translate(-3.811 -1.971)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9834",
    "data-name": "Path 9834",
    d: "M43.949,15.343a.869.869,0,1,0,0-1.737,7.491,7.491,0,0,1-5.3-2.171l-.174-.174a.86.86,0,1,0-1.216,1.216l.174.174A9.2,9.2,0,0,0,43.949,15.343Z",
    transform: "translate(-4.6 -0.526)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9835",
    "data-name": "Path 9835",
    d: "M34.261,31.261a.84.84,0,0,0,0,1.216,4.615,4.615,0,0,0,6.427,0,.86.86,0,0,0-1.216-1.216,2.944,2.944,0,0,1-4,0,.84.84,0,0,0-1.216,0Z",
    transform: "translate(-4.206 -3.154)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9836",
    "data-name": "Path 9836",
    d: "M44.96,49.607l.782,1.563v6.775a.869.869,0,1,0,1.737,0V54.558a5.618,5.618,0,0,0,4.69,2.519,5.7,5.7,0,0,0,5.211-3.387l1.737-4a6.131,6.131,0,0,0,.521-2.432V44.917A1.742,1.742,0,0,0,57.9,43.18H55.3a1.742,1.742,0,0,0-1.737,1.737v1.737c0,.174,0,.261.087.347l.608,1.216-2,2-2.606-8.251a6.488,6.488,0,0,0-3.474-4.082.835.835,0,1,0-.782,1.477A5.221,5.221,0,0,1,48,42.485l1.824,5.906H46.437l-.695-2a.879.879,0,1,0-1.65.608ZM57.9,47.262A3.889,3.889,0,0,1,57.555,49l-1.737,4a3.91,3.91,0,0,1-3.561,2.345,3.868,3.868,0,0,1-3.474-2.171l-1.65-3.04h3.214l.695,2a1.049,1.049,0,0,0,.608.608.7.7,0,0,0,.782-.261L55.9,49a.924.924,0,0,0,.174-1.042L55.3,46.48V44.917H57.9Z",
    transform: "translate(-5.525 -4.043)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9837",
    "data-name": "Path 9837",
    d: "M15.409,48.529a2.612,2.612,0,0,0-3.214.174A2.425,2.425,0,0,0,11.5,50.44a2.758,2.758,0,0,0,.695,1.737L14.714,54.7a.84.84,0,0,0,1.216,0l2.519-2.519a2.425,2.425,0,0,0,.695-1.737,2.758,2.758,0,0,0-.695-1.737A2.352,2.352,0,0,0,15.409,48.529Zm1.911,2.345-1.911,2L13.5,50.961a.734.734,0,0,1-.174-.521.931.931,0,0,1,.174-.521.734.734,0,0,1,.521-.174.931.931,0,0,1,.521.174l.347.347a.84.84,0,0,0,1.216,0l.347-.347a.682.682,0,0,1,.955,0,.734.734,0,0,1,.174.521.4.4,0,0,1-.261.434Z",
    transform: "translate(-1.249 -5.396)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(17 24)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(10 24)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9838",
    "data-name": "Path 9838",
    d: "M18,22.869a.821.821,0,0,0,.869.869h2.606a.869.869,0,1,0,0-1.737H18.869A.821.821,0,0,0,18,22.869Z",
    transform: "translate(-2.103 -1.971)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9839",
    "data-name": "Path 9839",
    d: "M13.343,22.869A.821.821,0,0,0,12.474,22H9.869a.869.869,0,1,0,0,1.737h2.606A.821.821,0,0,0,13.343,22.869Z",
    transform: "translate(-0.92 -1.971)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9840",
    "data-name": "Path 9840",
    d: "M12.261,31.261a.84.84,0,0,0,0,1.216,4.615,4.615,0,0,0,6.427,0,.86.86,0,0,0-1.216-1.216,2.944,2.944,0,0,1-4,0,.84.84,0,0,0-1.216,0Z",
    transform: "translate(-1.314 -3.154)",
    fill: "#00838d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9841",
    "data-name": "Path 9841",
    d: "M23.817,14.474a.821.821,0,0,0-.869-.869,7.491,7.491,0,0,1-5.3-2.171l-.174-.174a.86.86,0,1,0-1.216,1.216l.174.174a9.2,9.2,0,0,0,6.514,2.693A.821.821,0,0,0,23.817,14.474Z",
    transform: "translate(-1.84 -0.526)",
    fill: "#00838d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBeneficiaries);
export default __webpack_public_path__ + "static/media/Total-Beneficiaries.2b000c8e7a4a67d62a0fd27d117d9f7f.svg";
export { ForwardRef as ReactComponent };